import { api } from '@/core/api/';
import DocumentsService from './document.api';

const apiUrl = 'api/report';
export default {
  async downloadEvaluationReport(id) {
    await api.get(`${apiUrl}/evaluationreport/${id}`).then(({ data }) => {
      DocumentsService.downloadFile(data);
    });
  },
  async downloadAtReport(peiId) {
    await api.get(`${apiUrl}/downloadAtReport/${peiId}`).then(({ data }) => {
      DocumentsService.downloadFile(data);
    });
  },
  async downloadPEIReport(peiId) {
    await api.get(`${apiUrl}/peiorps/${peiId}`).then(({ data }) => {
      DocumentsService.downloadFile(data);
    });
  },
  async downloadUsageGuaranteeDocumentReport(params) {
    await api
      .get(`${apiUrl}/equipmentusageguaranteedocument`, {
        params: { ...params },
      })
      .then(({ data }) => {
        DocumentsService.downloadFile(data);
      });
  },
};
